/**
 * @generated SignedSource<<2cde70457d50555e3c6fbf5e08297a30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedItemDetails_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetailsAdditionalOptions_user" | "PdpRespSharedItemDetailsList_user">;
  readonly " $fragmentType": "PdpRespSharedItemDetails_user";
};
export type PdpRespSharedItemDetails_user$key = {
  readonly " $data"?: PdpRespSharedItemDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedItemDetails_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsList_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsAdditionalOptions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3bd6230c42a4d86b334036bc592cff7f";

export default node;
